import { theme as chakraTheme } from '@chakra-ui/theme';
import { breakpoints } from './device';

export const sizes = {
  ...chakraTheme.sizes,
  4.5: '1.125rem',
  11: '2.75rem',
  15: '3.75rem',
  21.5: '5.375rem',
  25: '6.25rem',
  30: '7.5rem',
  37: '9.25rem',
  37.5: '9.375rem',
  38: '9.5rem',
  41: '10.25rem',
  41.5: '10.375rem',
  42: '10.5rem',
  55: '13.75rem',
  62: '15.5rem',
  68: '17rem',
  70: '17.5rem',
  84: '21rem',
  88: '22rem',
  89: '22.25rem',
  90: '22.5rem',
  header: {
    md: '3.75rem',
  },
  modals: {
    sm: '25rem',
    md: '35rem',
    lg: '50rem',
    xl: '58rem',
  },
  container: breakpoints,
};
